'use string'

import {
    addSwipeListener, cardsAnimations, cardsCloseMobile, cardsCloseWebDesktop, cardsFunctionsMobile, cardsFunctionsWeb,
    closeHandler, closeMultiCards,
    createUnitCard, disableArrowButtons, keyButtonState,
    moveCardWhenBuildingDestroyed, multiCardsLogic, removeUnitCardListeners, setActiveClassHandler,
    updateUnitCard,
} from './unitCardFunctions';
import {
    closeUnitCardAnimation,
    createUnitCardAnimation,
    dragUnitCard, openAndCloseMobileOptionsCard,
    openAndCloseMobileUnitCard
} from "../cardsAnimation";
import { Buildings, cardsData, isMobile, settingsData, threeJsVariables } from '../../../settings';
import {CardTypes} from "../../../common";
import {
    changeActiveCardWhenBuildingClick,
    mobileHandleSearch,
    searchGetResults,
    searchResizeCanvas,
} from '../../search/search';
import {hideTooltip} from "../../flatTooltip/flatTooltip";
import {moveElements, rightNavMenuZIndexChange} from "../../navigation/right-nav-bar";
import {findSelectionAndCrmData} from "../../../functions";
import {changeCanvasSizeWhenCardIsOpened} from "../../controls/orbitControls";
import {selectionBoxesSetStatusColor} from "../../threejs/raycast";
import { changeLangToCurrent, getCurrentLang } from '../../language/langSwitcher';
import { Amenities } from '../../amenities/Amenities';

export class UnitCardClass {
    static cards = [];

    constructor(object) {
        this.engineId = object.engineId;
        this.status = object.status;
        this.bmbyPropID = object.bmbyPropID;
        this.floor = object.floorNum;
        this.propNum = object.propNum;
        this.propType = object.propType;
        this.price = object.salePrice;
        this.infoPoints = {
            balconySize: object.balconySize,
            bathRooms: object.bathRooms,
            gardenSize: object.gardenSize,
            parking: object.parking,
            toilets: object.toilets,
            roomNum: object.roomNum,
            totalSpace: object.totalSpace,
            facing: object.facing,
            modelName: object.modelName,
        };
        this.plans = {
            plan2D: object.assets.plan2D,
            plan2DVertical: object.assets.plan2DVertical,
            preview2D: object.assets.preview2D,
            tours360: object.assets.tours360,
            vantage: object.assets.vantage,
            gallery: object.assets.gallery
        }
    }

    createCard() {
        const currentCard = UnitCardClass.findCard();
        if (UnitCardClass.cards.length <= 2 && cardsData.multiplyCards || !currentCard.html) {
            const card = createUnitCard(this);
            const searchItem = document.querySelector(`li.search__result-item:not(.similar-item)[data-engineid=${this.engineId}]`);

            if (searchItem){

                searchItem.classList.add('active');
                searchItem.classList.add('active-card');

                searchItem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
            // this.setNode(card);
        } else {
            this.updateCard();
        }

        Amenities.hide();
    }

    updateCard() {
        const card = updateUnitCard(this);
        searchGetResults();
        // this.setNode(card);
    }

    setNode(node) {
        this.html = node;
    }

    static findCard(id, className) {
        if (className) {
            return UnitCardClass.cards.find(card => card.html.classList.contains(className));
        }

        if (!id) {
            return UnitCardClass.cards[0];
        }

        return UnitCardClass.cards.find(card => card.engineId === id);
    }

    setAnimationsToCard() {
        cardsAnimations.apply(this);
    }

    setFunctionsToWebCard() {
        if (isMobile) return;
        cardsFunctionsWeb.apply(this)
    }

    setFunctionsToMobileCard() {
        if (!isMobile) return;
        cardsFunctionsMobile();
    }

    static closeMobileCard() {
        if (UnitCardClass.cards.length < 1) return;
        cardsCloseMobile();
    }

    closeWebOrDesktopCard(card, id) {
        cardsCloseWebDesktop(card, id);
    }

    setFunctionsToMultiCards(card) {
     multiCardsLogic(card)
    }

    setKeyPlanButtonState(card) {
       keyButtonState(card);
    }

    static changeTowerNameWhenLanguageSwitching(){
        if (!UnitCardClass.cards.length) return;

        const activeBuildingTowerName = Buildings.getActiveBuilding().info.towerName;

        let name;

        if (Array.isArray(activeBuildingTowerName)){
            name = activeBuildingTowerName.find(name => name.lang === getCurrentLang()).value;
        } else {
            name = activeBuildingTowerName;
        }

        UnitCardClass.cards.forEach(card =>{
            const cardTowerName = card.html.querySelector('.card__tower-name');
            if (cardTowerName)
                cardTowerName.textContent = name;
        });
    }

    static activateMutliCardsMode(target) {
        cardsData.multiplyCards = true;
        const card = UnitCardClass.findCard();
        card.html.classList.add('active');
        target.classList.add('active');

        disableArrowButtons();
    }

    static deactivateMutliCardsMode(target) {
        cardsData.multiplyCards = false;
        const cardActive = UnitCardClass.findCard(false, 'active');
        const cardNonActive = UnitCardClass.findCard(false, 'non-active');
        target.classList.remove('active');
        cardActive.html.classList.remove('active');

        disableArrowButtons();

        if (cardNonActive) {
            const cardNonActiveId = cardNonActive.html.getAttribute('data-engineid');
            cardNonActive.closeWebOrDesktopCard(cardNonActive.html, cardNonActiveId);
        }
    }

    static closeMultipleCards() {
        closeMultiCards();
    }
}